import * as choosePhotoCustomerSlice from './choosePhotoCustomerSlice';
import * as selectors from './selectors';
import * as actions from './actions';

export const reducers = {
  choosePhotoCustomer:
    choosePhotoCustomerSlice.choosePhotoCustomerSlice.reducer,
};
export { actions, selectors, choosePhotoCustomerSlice };
